import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ConfigProvider } from "../../config-provider.service";
import { ActivatedRoute } from '@angular/router';
import { ExercicesProvider } from '../../exercices/providers/exercices-provider';
import { PhaseProvider } from '../../annual-plan/providers/phase-provider.services';
import { AnnualPlanService } from '../../annual-plan/providers/annual-plans.services';
import { AnnualPlanData } from '../../annual-plan/merger/annual-plan-data-merger';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import {
  MobileModuleContentComponent,
  ModuleMenu
} from "../../common/components/mobile-module-content/mobile-module-content";
import { Organization } from "../../common/models/organization";
import { Athlete } from "../../common/models/athlete";
import { User } from "../../common/models/user";
import { AnnualPlan } from "../../common/models/annual-plan";
import { Week } from "../../common/models/week";
import { Phase } from "../../common/models/phase";
import { ExerciceCategory } from "../../common/models/exercice-category";
import { AnnualPlanMacroCycle } from "../../common/models/annual-plan-macro-cycle";
import { AnnualPlanPhase } from "../../common/models/annual-plan.phase";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { FlexLayoutModule } from "@angular/flex-layout";
import { TranslateModule } from "@ngx-translate/core";
import { DefaultPipe } from "../../common/pipes/default";
import { AnnualPlanGraphComponent } from "../../annual-plan/components/graph/annual-plan-graph.component";
import { NgForOf, NgIf } from "@angular/common";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { SecondsToDHMPipe } from "../../common/pipes/seconds-to-DHM-pipe";

@Component({
  selector: 'app-mobile-plan',
  providers: [],
  styleUrls: ['./mobile.plan.component.scss'],
  standalone: true,
  imports: [
    MobileModuleContentComponent,
    MobileSideMenuComponent,
    MobilePageContentComponent,
    FlexLayoutModule,
    TranslateModule,
    DefaultPipe,
    AnnualPlanGraphComponent,
    NgIf,
    NgForOf,
    MobileHeaderComponent,
    SecondsToDHMPipe,
  ],
  templateUrl: './mobile.plan.component.html'
})
export class MobilePlanComponent implements OnInit, OnDestroy {

    get f() {
        return this.annualPlanForm.controls;
    }
    public mainActions: ModuleMenu[] = [];
    public pageTitle = 'AnnualPlanShow';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;
    public annualPlan: AnnualPlan = {} as AnnualPlan;

    public weeks: Week[] = [];
    public clickedWeek: Week = {} as Week;
    public phases: Phase[] = [];

    public exerciseCategories: ExerciceCategory[] = [];
    public annualPlanMacroCycles: AnnualPlanMacroCycle[] = [];
    public annualPlanPhases: AnnualPlanPhase[] = [];

    public isSubmitting = false;
    public annualPlanForm: FormGroup = {} as FormGroup;

    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        public dialog: MatDialog,
        private annualPlanProvider: AnnualPlanService,
        private route: ActivatedRoute,
        private exerciseProvider: ExercicesProvider,
        private phaseProvider: PhaseProvider,
    ) {
    }

    public ngOnInit() {
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { //{ organization: Organization; athlete: Athlete }
                this.organization = data.organization;
                this.athleteUser = data.athlete;

                this.loadAnnualPlan();
                this.exerciseProvider.getExerciseCategories(this.organization).subscribe((categories) => {
                  this.exerciseCategories = categories;
                })
                this.phaseProvider.findAll(this.organization).subscribe((phases) => {
                  this.phases = phases;
                })
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    private loadAnnualPlan() {
        this.subscriptions.push(
            this.annualPlanProvider.findActiveByAthleteUserId(this.organization, this.athleteUser.id!).subscribe((data: AnnualPlanData) => {
                this.annualPlan = data['plan'];
                this.weeks = data['weeks'];
                this.annualPlanPhases = data['phases'];
                this.annualPlanMacroCycles = data['macroCycles'];

                this.isLoading = false;
            })
        );
    }
}
